import React, { useEffect, useState, useRef } from 'react'
import { useShow, IResourceComponentsProps, useGetIdentity, useOne, useNavigation, useList, useInvalidate } from '@pankod/refine-core'
import { ErrorComponent, useModal } from '@pankod/refine-antd'
import { Radio, Tooltip } from 'antd'
import type { RadioChangeEvent } from 'antd'
import type { ColumnsType } from 'antd/lib/table'
import { IGrade, IQuestion, IStrand, IWorkRequest } from 'interfaces'
import { EditQuestion } from './edit'
import ReactMarkdown from 'react-markdown'
import { Editor } from '@tinymce/tinymce-react'
import { getAllDistinctCustomTags, getDetailsById, getTeacherLevelByStrand } from 'gql/query'
// import { useInvalidate } from '@pankod/refine-core'
import './style.css'
import { CheckUserAccess } from 'components/accessability'
import {
  Space,
  Table,
  Tag,
  Progress,
  Breadcrumb,
  Icons,
  Button,
  PageHeader,
  Typography,
  Skeleton,
  Descriptions,
  Divider,
  EditButton,
  Image,
  useModalForm,
  Col,
  Row,
} from '@pankod/refine-antd'
import {
  createLogForApproval,
  createLogForReview,
  createLogForReviewRequireAmending,
  createLogOpenRequireAmending,
  createLogPublished,
  createLogRejectedAtApproval,
  createLogRejectedAtRewiew,
  createNotificationForApproval,
  createNotificationForReview,
  createNotificationForReviewRequireAmending,
  createNotificationOpenRequireAmending,
  createNotificationRejectedAtApproval,
  createNotificationRejectedAtRewiew,
  updateQuestionApprover,
  updateQuestionReviewer,
  updateQuestionStatus,
} from 'gql/mutations'
import metaData from 'metadata/questions'
import wr_metadata from 'metadata/workrequests'
import { CompletionStatus, getWorkRequestStatusCount } from 'helpers'
import { nhost } from 'utility'
import {
  createMailForApproval,
  createMailForReview,
  createMailForReviewRequireAmending,
  createMailOpenRequireAmending,
  createMailRejectedAtApproval,
  createMailRejectedAtRewiew,
} from 'helpers'
import QuestionLogs from 'components/questionlogs'
import QuestionUsageAnalysis from 'components/questionUsageAnalysis'
import { useUserContext } from 'context/user'
import DiscriminationIndex from 'components/questions/discrimination_index'
import RichTextEditor from 'components/questions/rich_text_editor'
import RichTextRender from 'components/questions/rich_text_render'
import SunTextEditor from 'components/questions/sun_text_editor'
import { getAttemptCount } from 'helpers/question/uploadedQuetionForReviewProcess'
const { Text } = Typography
interface romanType {
  [key: number]: string
}
interface alphabetsType {
  [key: number]: string
}
type ReviewerApprover = {
  reviewer_id: string
  reviewer_name: string
  approvers: object[]
}
const roman: romanType = { 1: 'i', 2: 'ii', 3: 'iii', 4: 'iv', 5: 'v', 6: 'vi', 7: 'vii', 8: 'viii' }
const alphabets: alphabetsType = { 1: 'a', 2: 'b', 3: 'c', 4: 'd', 5: 'e', 6: 'f', 7: 'g', 8: 'h' }
interface MCQDataType {
  type?: string
  option_text: string
  option_image_id: string
  option_image_name: string
  option_insight: string
  option_flag: string
}

interface MatchDataType {
  left_label_text: string
  right_label_text: string
  option_insight: string
  option_comments: string
  left_label_image: string
  right_label_image: string
}

interface FillDataType {
  option_image_id: any
  right_answer: string
  option_comments: string
}

interface ShortAnswerDataType {
  component_image_id: any
  component_name: string
  rating_1: string
  rating_2: string
  rating_3: string
  rating_4: string
  weightage: string
}

const MCQColumns: ColumnsType<MCQDataType> = [
  {
    title: 'Option ',
    dataIndex: 'option_text',
    render: (_, record) => {
      if (record.option_image_id && record?.type === 'Image') {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.option_image_id })
        return <>{publicUrl && <Image width={100} src={publicUrl} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.option_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Option Flag',
    dataIndex: 'option_flag',
    render: (_, { option_flag }) => {
      let color = 'geekblue'
      if (option_flag === 'Right Answer' || option_flag === 'RA') {
        color = 'green'
      }
      if (option_flag === 'Most Wrong' || option_flag === 'WW') {
        color = 'volcano'
      }
      return <Tag color={color}>{option_flag?.toUpperCase()}</Tag>
    },
  },
  {
    title: 'Option Insight',
    dataIndex: 'option_insight',
    render:(_,record)=> {
     if(record?.option_insight){
      return(
        <>
        <RichTextRender content={record?.option_insight} styles={{ width: undefined, height: undefined }} />
        </>
      )
     }
    }
    
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const MatchColumns: ColumnsType<MatchDataType> = [
  {
    title: 'Left Label',
    dataIndex: 'left_label_text',
    render: (_, record) => {
      if (record?.left_label_image) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.left_label_image })
        return <>{publicUrl && <Image width={100} height={100} src={publicUrl} style={{ marginLeft: 0, objectFit: 'contain' }} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.left_label_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Right Label',
    dataIndex: 'right_label_text',
    render: (_, record) => {
      if (record?.right_label_image) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.right_label_image })
        return <>{publicUrl && <Image width={100} height={100} src={publicUrl} style={{ marginLeft: 0, objectFit: 'contain' }} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.right_label_text} styles={{ width: undefined, height: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Lebel Insight',
    dataIndex: 'option_insight',
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const FillColumns: ColumnsType<FillDataType> = [
  {
    title: 'Right Answer',
    dataIndex: 'right_answer',

    render: (_, record) => {
      if (record.option_image_id) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.option_image_id })
        return <>{publicUrl && <Image width={100} src={publicUrl} />}</>
      } else {
        return (
          <>
            <RichTextRender content={record?.right_answer} styles={{ height: undefined, width: undefined }} />
          </>
        )
      }
    },
  },
  {
    title: 'Reviewer Comments',
    dataIndex: 'reviewer_comments',
  },
  {
    title: 'Approver Comments',
    dataIndex: 'approver_comments',
  },
]

const ShortAnswerColumns: ColumnsType<ShortAnswerDataType> = [
  {
    title: 'Component Name',
    dataIndex: 'component_name',
    render: (_, record) => {
      if (record.component_image_id) {
        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.component_image_id })
        return <>{publicUrl && <Image width={100} src={publicUrl} />}</>
      } else {
        return <>{record?.component_name}</>
      }
    },
  },
  {
    title: 'Rating 1',
    dataIndex: 'rating_1',
  },
  {
    title: 'Rating 2',
    dataIndex: 'rating_2',
  },
  {
    title: 'Rating 3',
    dataIndex: 'rating_3',
  },
  {
    title: 'Rating 4',
    dataIndex: 'rating_4',
  },
  {
    title: 'Weightage',
    dataIndex: 'weightage',
  },
]

export const QuestionShow: React.FC<IResourceComponentsProps> = () => {
  const { data: user } = useGetIdentity()
  const invalidate = useInvalidate()
  const role = user?.defaultRole
  const { show } = useNavigation()
  const { userRole, qcreatorList, qapproverList, qreviewerList, vcreatorList } = useUserContext()
  const [questionStatus, setQuestionStatus] = useState<string>('')
  const [reviewers, setReviewers] = useState<string[]>([])
  const [approvers, setApprovers] = useState<string[]>([])
  const [teacherLevel, setTeacherLevel] = useState('')
  const [customTags, setCustomTags] = useState([])
  const [questionAttemptedCount, setQuestionAttemptedCount] = useState(0)
  const [fetchAttemptedCountLoading, setAttemptedCountLoading] = useState<boolean>(false)

  const [errorCode, setErrorCode] = useState<number>(200)
  const editorRef = useRef(null)

  const { queryResult, setShowId } = useShow<IQuestion>({
    metaData,
    liveMode: 'auto',
  })

  const { data, isLoading } = queryResult
  const record = data?.data
  const { data: workRequestRecord } = useOne<IWorkRequest>({
    resource: 'work_requests',
    id: record?.work_request_id || '',
    metaData: wr_metadata,
    queryOptions: {
      enabled: !!record?.work_request_id,
    },
  })

  const findDistinctCustomTag = async () => {
    try {
      const customTagsResponse: any = await getAllDistinctCustomTags()
      if (customTagsResponse && customTagsResponse.questions) {
        const customTagsArray = customTagsResponse.questions.reduce((acc: any, item: any) => {
          const customTag = item.custom_tag
          if (customTag) {
            acc.push({ value: customTag, label: customTag })
          }
          return acc
        }, [])

        if (customTagsArray.length > 0) {
          setCustomTags(customTagsArray)
        }
      }
    } catch (error) {
      console.error('Error fetching distinct custom tags:', error)
    }
  }
  const getQuestionCount = async () => {
    setAttemptedCountLoading(true)
    if (record && record?.id) {
      const count = await getAttemptCount(record?.id)
      setQuestionAttemptedCount(count)
    }
    setAttemptedCountLoading(false)
  }
  const { modalProps: DIModalProps, show: showDIModal, close: closeDIModal } = useModal()
  useEffect(() => {
    invalidate({
      resource: 'questions',
      invalidates: ['detail'],
      id: record?.id,
    })
    getQuestionCount()
    findDistinctCustomTag()
  }, [userRole, record])

  useEffect(() => {
    let code: any = 200
    code = CheckUserAccess('question', 'show', user?.id, record, userRole)
    setErrorCode(code)
    console.log({ code, userRole })
  }, [user, record, userRole])

  useEffect(() => {
    if (workRequestRecord?.data) setReviewers(workRequestRecord?.data?.reviewer_ids ?? [])
  }, [workRequestRecord])

  useEffect(() => {
    let arr: string[] = []
    if (workRequestRecord?.data && record) {
      const approverIds = workRequestRecord?.data?.workRequestApprovers?.filter((list: any) => list?.reviewer_id === record?.reviewer_id)
      if (approverIds?.length > 0) {
        approverIds.forEach((elem: any) => {
          if (!arr.includes(elem?.approver_id)) arr.push(elem?.approver_id)
        })
        setApprovers(arr)
      }
      // if (approverIds && approverIds[0])
      //  setApprovers(approverIds[0]?.approver_ids ?? [])

      //  if (approverIds && approverIds[0])

      // const approverIds = workRequestRecord?.data?.approver_ids?.filter((list: any) => list?.reviwer_id_selected === record?.reviewer_id)
    }
  }, [workRequestRecord, record, userRole])

  useEffect(() => {
    if (workRequestRecord?.data === undefined && record) {
      setApprovers([record?.approver_id])
      setReviewers([record?.reviewer_id])
    }
  }, [record, workRequestRecord])
  console.log('workRequestRecord', approvers)
  const [value, setValue] = useState(1)

  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close,
  } = useModalForm({
    resource: 'questions',
    action: 'edit',
    metaData,
    redirect: false,
  })
  editModalProps.width='98%'
  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value)
  }

  const handleQUestionStatusChange = (status: string) => {
    if (record?.id) {
      let reviewerId: any = null
      let approverId: any = null
      if (userRole === 'qcreator' || userRole === 'variantcreator') {
        if (status === 'For Review') {
          if (record?.reviewer_id !== null && record?.reviewer_id !== '') {
            reviewerId = record?.reviewer_id
          } else {
            if (JSON.stringify(workRequestRecord?.data?.reviewer_ids) !== '[]') {
              // let currentCount = workRequestRecord?.data?.question_reviewer_approver?.length
              // if (currentCount === 0) {
              const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } =
                getWorkRequestStatusCount(workRequestRecord?.data)

              const reviewerIndex =
                (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length

              reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]

              // }
            }
          }
        }
      } else if (userRole === 'qreviewer') {
        if (status === 'For Approval') {
          // alert(1)
          if (record?.approver_id !== null && record?.approver_id !== '') {
            approverId = record?.approver_id
          } else {
            if (JSON.stringify(workRequestRecord?.data?.workRequestApprovers) !== '[]') {
              const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(workRequestRecord?.data)
              const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length

              approverId = approvers[approverIndex]
            }
          }
        }
        reviewerId = record?.reviewer_id
      } else {
        approverId = record?.approver_id
        reviewerId = record?.reviewer_id
      }
      if (status === 'For Review') {
        if (reviewerId) {
          let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === reviewerId)[0]

          updateQuestionStatus(record.id, status)
            .then(() => updateQuestionReviewer(record.id, reviewerId))
            .then(() => createNotificationForReview(user?.id, reviewerId, workRequestRecord?.data, record?.question_id))
            .then(() => createLogForReview(reviewerId, workRequestRecord?.data, record?.id))
            .then(() => getWorkRequestStatusCount(workRequestRecord?.data))
            .then(() =>
              createMailForReview(workRequestRecord?.data, record?.question_id, reviewerDetails?.user?.displayName, reviewerDetails?.user?.email)
            )
          setQuestionStatus(status)
        }
      }
      if (status === 'For Approval') {
        if (approverId) {
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approverId)[0]
           console.log(record,"record is this",)
          updateQuestionStatus(record.id, status)
            .then(() => updateQuestionApprover(record.id, approverId))
            .then(() => createNotificationForApproval(user?.id, approverId, workRequestRecord?.data, record?.question_id))
            .then(() => createLogForApproval(record?.reviewer_id, approverId, workRequestRecord?.data, record?.id))
            .then(() => getWorkRequestStatusCount(workRequestRecord?.data))
            .then(() =>
              createMailForApproval(workRequestRecord?.data, record?.question_id, approverDetails?.user?.displayName, approverDetails?.user?.email)
            )
          setQuestionStatus(status)
        }
      }
      // if (status === 'For Review' && reviewers && reviewers?.length > 0) {
      //   const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } = getWorkRequestStatusCount(
      //     workRequestRecord?.data
      //   )
      //   const reviewerIndex =
      //     (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
      //   const reviewerId = workRequestRecord?.data?.reviewer_ids[reviewerIndex]
      //   if (reviewerId) {
      //     updateQuestionStatus(record.id, status)
      //       .then(() => updateQuestionReviewer(record.id, reviewerId))
      //       .then(() => createNotificationForReview(user?.id, reviewerId, workRequestRecord?.data, record?.question_id))
      //       .then(() => createLogForReview(reviewerId, workRequestRecord?.data, record?.id))
      //       .then(() => CompletionStatus(workRequestRecord?.data))
      //       .then(() => createMailForReview(workRequestRecord?.data, record?.question_id))
      //     setQuestionStatus(status)
      //   }
      // }
      // if (status === 'For Approval' && approvers && approvers?.length > 0) {
      //   const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(workRequestRecord?.data)
      //   const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % approvers?.length
      //   const approverId = approvers[approverIndex]
      //   if (approverId) {
      //     updateQuestionStatus(record.id, status)
      //       .then(() => updateQuestionApprover(record.id, approverId))
      //       .then(() => createNotificationForApproval(user?.id, approverId, workRequestRecord?.data, record?.question_id))
      //       .then(() => createLogForApproval(record?.reviewer_id, approverId, workRequestRecord?.data, record?.id))
      //       .then(() => CompletionStatus(workRequestRecord?.data))
      //       .then(() => createMailForApproval(workRequestRecord?.data, record?.question_id))
      //     setQuestionStatus(status)
      //   }
      // }
      if (status !== 'For Review' && status !== 'For Approval') {
        updateQuestionStatus(record.id, status).then(() => getWorkRequestStatusCount(workRequestRecord?.data))
        setQuestionStatus(status)
      }
    }
    
    invalidate({
      resource: 'questions',
      invalidates: ['detail'],
      id: record?.id,
    })
  }

  useEffect(() => {
    if (record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '') {
      getTeacherLevelByStrand(record?.strand_id).then((resp: any) => {
        setTeacherLevel(resp?.strands?.[0]?.teacher_level?.name)
      })
    }
  }, [record])
  useEffect(() => {
    if (record?.status) setQuestionStatus(record?.status)
      //if user uploaded question only with strand id
      if ((!record?.competency_id && record?.tn_taxonomy_id) || (!record?.tn_taxonomy_id && record?.strand_id)) {
        if(record?.tn_taxonomy_id){
          getDetailsById(record?.tn_taxonomy_id,'tn_taxonomys','id',`{competency_id}`).then((resp:any)=>{
            editFormProps.form?.setFieldsValue({competency_id: resp[0]?.competency_id})
            record.competency_id = resp[0]?.competency_id
          })
        }
        if(record?.strand_id){
          getDetailsById(record?.strand_id,'strands','id',`{taxonomy_id competency_id}`).then((resp:any)=>{
            if(editFormProps?.initialValues && resp[0]?.competency_id && resp[0]?.taxonomy_id){
              editFormProps.form?.setFieldsValue({competency_id: resp[0]?.competency_id})
              editFormProps.form?.setFieldsValue({tn_taxonomy_id: resp[0]?.taxonomy_id})
              record.competency_id = resp[0]?.competency_id
              record.tn_taxonomy_id = resp[0]?.taxonomy_id
            }
          })
        }
      }
  }, [record])
  const gradeList = useList<IGrade>({
    resource: 'grades',
    metaData: {
      fields: ['id', 'name'],
    },
    config: {
      pagination: { pageSize: 1000 },
    },
  })

  // const renderGrades = (item: any) => {
  //   let text: object[] = []
  //   for (let i = 0; i < item?.length; i++) {
  //     let result = gradeList?.data?.data?.filter((grade: any) => item[i] === grade?.id)[0]
  //     if (result !== undefined) {
  //       text.push(<Tag>{result?.name}</Tag>)
  //     }
  //   }
  //   return text
  // }

  const renderApproverReviewerUsers = () => {
    let arr_reviewer: object[] = []
    let arr_approver: ReviewerApprover[] = []
    JSON.stringify(record?.work_request?.workRequestReviewers) !== '{}' &&
      record?.work_request?.workRequestReviewers?.map((item: any) => {
        if (record?.work_request?.workRequestApprovers?.length > 0) {
          record?.work_request?.workRequestApprovers?.map((approv: any) => {
            if (approv?.reviewer_id === item?.user_id) {
              var found = arr_approver.findIndex(function (doundIndex: any) {
                return doundIndex?.reviewer_id === approv.reviewer_id
              })
              if (found > -1) {
                arr_approver[found]?.approvers?.push(approv?.userByApprover?.displayName)
              } else {
                let app_arr: object[] = []
                app_arr.push(approv?.userByApprover?.displayName)
                arr_approver.push({
                  reviewer_id: approv?.reviewer_id,
                  reviewer_name: approv?.userByReviewerId[0]?.displayName,
                  approvers: app_arr,
                })
              }
            } else {
              arr_approver.push({
                reviewer_id: item?.user_id,
                reviewer_name: item?.userByReviewerId?.displayName,
                approvers: [],
              })
            }
          })
        } else {
          arr_approver.push({
            reviewer_id: item?.user_id,
            reviewer_name: item?.userByReviewerId?.displayName,
            approvers: [],
          })
        }
      })
    arr_approver = arr_approver.filter(
      (elem: any, index: any, self: any) =>
        self.findIndex((t: any) => {
          return t.reviewer_id === elem.reviewer_id
        }) === index
    )

    // if (JSON.stringify(record?.work_request?.workRequestApprovers) !== '{}') {
    //   record?.work_request?.workRequestApprovers?.map((approv: any) => {
    //     var found = arr_approver.findIndex(function (doundIndex: any) {
    //       return doundIndex?.reviewer_id === approv.reviewer_id
    //     })
    //     if (found > -1) {
    //       arr_approver[found]?.approvers.push(approv?.userByApprover?.displayName)
    //     } else {
    //       let app_arr: object[] = []
    //       app_arr.push(approv?.userByApprover?.displayName)
    //       arr_approver.push({
    //         reviewer_id: approv?.reviewer_id,
    //         reviewer_name: approv?.userByReviewerId[0]?.displayName,
    //         approvers: app_arr,
    //       })
    //     }
    //   })
    // } else if (JSON.stringify(record?.work_request?.workRequestReviewers) !== '{}') {
    //   record?.work_request?.workRequestReviewers?.map((item: any) => {
    //     arr_reviewer.push(item?.userByReviewerId?.displayName)
    //   })
    // }
    console.log(workRequestRecord, 'workRequest Record')
    return (
      <>
        {record?.request_type !== 'Uploaded' ? (
          arr_approver?.length > 0 ? (
            <>
              <Col xs={24} lg={16}>
                <div>
                  <b>{`Reviewers    &    Approvers`}</b>
                  {arr_approver?.map((item: any, i: any) => (
                    <div style={{ display: 'flex', padding: '2px 0' }}>
                      {userRole === 'qcreator' || userRole === 'qapprover' ? (
                        <div style={{ display: 'block', padding: '2px 0' }}> {item?.reviewer_name !== '' ? `R${i + 1}` : ''}</div>
                      ) : (
                        <div style={{ display: 'block', padding: '2px 0' }}> {`${item?.reviewer_name}  :   `}</div>
                      )}
                      {item?.approvers?.length > 0 &&
                        item?.approvers?.map((approv: any, index: any) => (
                          <div style={{ display: 'block', padding: '2px 0' }}>
                            {userRole === 'qcreator' || userRole === 'qreviewer' ? (
                              <Text keyboard>{approv !== '' ? `A${index + 1}` : null}</Text>
                            ) : (
                              <Text keyboard>{approv}</Text>
                            )}
                          </div>
                        ))}
                    </div>
                  ))}
                </div>
              </Col>
            </>
          ) : arr_reviewer?.length > 0 ? (
            <>
              <Col xs={24} lg={16}>
                <div>
                  <b>{`Reviewers`}</b>
                  {arr_reviewer?.map((item: any, index: any) =>
                    userRole === 'qcreator' || userRole === 'qapprover' ? (
                      <div style={{ display: 'block', padding: '2px 0' }}> {item !== '' ? `R${index + 1}` : null}</div>
                    ) : (
                      <div style={{ display: 'block', padding: '2px 0' }}> {item}</div>
                    )
                  )}
                </div>
              </Col>
            </>
          ) : (
            <>
              <Col xs={24} lg={8}>
                <div>
                  <b>{`Reviewers    &    Approvers`}</b>
                </div>
              </Col>
            </>
          )
        ) : null}
      </>
    )
  }

  return (
    <>
      {errorCode === 200 ? (
        <PageHeader
          className="site-page-header-responsive"
          ghost={false}
          // title={`#${record?.question_id ?? ''} - ${record?.grade?.name ?? ''} ${record?.topic?.sub_theme?.theme?.subject?.name ?? ''} ${
          //   record?.question_type?.name
          // }`}
          title={
            <>
              #{record?.question_id ?? ''} - {record?.grade?.name ?? ''} {record?.topic?.sub_theme?.theme?.subject?.name ?? ''}{' '}
              {record?.question_type?.name}{' '}
              <Tag color="blue">Attempted: {fetchAttemptedCountLoading ? 'Loading...' : questionAttemptedCount ?? 0}</Tag>
            </>
          }
          extra={[
            (userRole === 'admin' || userRole === 'qbincharge' || userRole === 'subjectincharge') && <QuestionLogs questionId={record?.id} />,
            (userRole === 'admin' || userRole === 'qbincharge' || userRole === 'subjectincharge') && (
              <QuestionUsageAnalysis questionId={record?.id} questionTitle={record?.title} />
            ),
            <Button key="close" onClick={() => window.history.back()} icon={<Icons.LeftOutlined />}>
              Back
            </Button>,
            ((workRequestRecord?.data?.request_type === 'Q' && userRole === 'qcreator' && workRequestRecord?.data?.creator_id === user?.id) ||
              (workRequestRecord?.data?.request_type === 'V' && userRole === 'variantcreator')) && (
              <Button
                key="submit for review"
                onClick={() => {
                  handleQUestionStatusChange('For Review')
                }}
                disabled={(questionStatus !== 'Open' && questionStatus !== 'Open (Require Amending)') || reviewers?.length < 1}
              >
                Submit for Review
              </Button>
            ),
            userRole === 'qreviewer' && (
              <Button
                key="rejected at review"
                onClick={() => {
                  let creatorDetails = []
                  if (workRequestRecord?.data?.request_type === 'Q') {
                    creatorDetails = qcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
                  }
                  if (workRequestRecord?.data?.request_type === 'V') {
                    creatorDetails = vcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
                  }
                  handleQUestionStatusChange('Rejected at Review')
                  record && createNotificationRejectedAtRewiew(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
                  record && createLogRejectedAtRewiew(record?.reviewer_id, workRequestRecord?.data, record?.id)
                  createMailRejectedAtRewiew(
                    workRequestRecord?.data,
                    record?.question_id,
                    creatorDetails?.user?.displayName,
                    creatorDetails?.user?.email
                  )
                }}
                disabled={questionStatus !== 'For Review' && questionStatus !== 'For Review (Require Amending)'}
              >
                Reject
              </Button>
            ),
            userRole === 'qreviewer' && (
              <Button
                key="require amending at review"
                onClick={() => {
                  let creatorDetails = []
                  if (workRequestRecord?.data?.request_type === 'Q') {
                    creatorDetails = qcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
                  }
                  if (workRequestRecord?.data?.request_type === 'V') {
                    creatorDetails = vcreatorList.filter((item: any) => item?.id === record?.creator_id)[0]
                  }
                  handleQUestionStatusChange('Open (Require Amending)')
                  record && createNotificationOpenRequireAmending(user?.id, record?.creator_id, workRequestRecord?.data, record?.question_id)
                  record && createLogOpenRequireAmending(record?.reviewer_id, record?.creator_id, workRequestRecord?.data, record?.id)
                  createMailOpenRequireAmending(
                    workRequestRecord?.data,
                    record?.question_id,
                    creatorDetails?.user?.displayName,
                    creatorDetails?.user?.name
                  )
                }}
                hidden={questionStatus === 'For Review (Require Amending)' || questionStatus === 'For Approval' || questionStatus === 'Published'}
                disabled={questionStatus !== 'For Review' && questionStatus !== 'For Review (Require Amending)'}
              >
                Require Amending
              </Button>
            ),

            userRole === 'qreviewer' && (
              <Button
                key="submit to approval"
                onClick={() => handleQUestionStatusChange('For Approval')}
                disabled={
                  approvers?.length > 0 && (questionStatus === 'For Review' || questionStatus === 'For Review (Require Amending)') ? false : true
                }
              >
                Submit for Approval
              </Button>
            ),
            userRole === 'qapprover' && (
              <Button
                key="rejected at approval"
                onClick={() => {
                  let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === record?.reviewer_id)[0]

                  handleQUestionStatusChange('Rejected at Approval')
                  record &&
                    createNotificationRejectedAtApproval(
                      user?.id,
                      record?.creator_id,
                      record?.reviewer_id,
                      workRequestRecord?.data,
                      record?.question_id
                    )
                  record && createLogRejectedAtApproval(record?.approver_id, workRequestRecord?.data, record?.id)
                  createMailRejectedAtApproval(
                    workRequestRecord?.data,
                    record?.question_id,
                    reviewerDetails?.user?.displayName,
                    reviewerDetails?.user?.email
                  )
                }}
                disabled={questionStatus !== 'For Approval'}
              >
                Reject
              </Button>
            ),
            userRole === 'qapprover' && (
              <Button
                key="require amending at approval"
                onClick={() => {
                  let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === record?.reviewer_id)[0]

                  handleQUestionStatusChange('For Review (Require Amending)')
                  record && createNotificationForReviewRequireAmending(user?.id, record?.reviewer_id, workRequestRecord?.data, record?.question_id)
                  record && createLogForReviewRequireAmending(record?.approver_id, record?.reviewer_id, workRequestRecord?.data, record?.id)
                  createMailForReviewRequireAmending(
                    workRequestRecord?.data,
                    record?.question_id,
                    reviewerDetails?.user?.displayName,
                    reviewerDetails?.user?.email
                  )
                }}
                disabled={questionStatus !== 'For Approval'}
              >
                Require Amending
              </Button>
            ),
            userRole === 'qapprover' && (
              <Button
                key="approved"
                onClick={() => {
                  handleQUestionStatusChange('Published')
                  record && createLogPublished(record?.approver_id, workRequestRecord?.data, record?.id)
                }}
                disabled={questionStatus !== 'For Approval'}
              >
                Approve
              </Button>
            ),

            userRole === 'subjectincharge' ||
            userRole === 'admin' ||
            userRole === 'qbincharge' ||
            (userRole === 'qcreator' &&
              (questionStatus === 'Open' || questionStatus === 'Open (Require Amending)') &&
              (workRequestRecord ? workRequestRecord?.data?.creator_id === user?.id : true)) ||
            (workRequestRecord?.data?.request_type === 'V' &&
              userRole === 'variantcreator' &&
              (questionStatus === 'Open' || questionStatus === 'Open (Require Amending)')) ||
            (userRole === 'qreviewer' && (questionStatus === 'For Review' || questionStatus === 'For Review (Require Amending)')) ||
            (userRole === 'qapprover' && questionStatus === 'For Approval') ? (
              <EditButton
                key="edit"
                disabled={
                  (userRole !== 'subjectincharge' && userRole !== 'admin' && userRole !== 'qbincharge' && record?.status === 'Published') ||
                  record?.status === 'Retired'
                }
                icon={<Icons.EditOutlined />}
                type="primary"
                recordItemId={record?.id}
                onClick={() => {
                  editShow(record?.id)
                }}
              >
                Edit
              </EditButton>
            ) : null,
          ]}
        >
          <Descriptions size="small">
            {userRole !== 'qcreator' && userRole !== 'qreviewer' && userRole !== 'qapprover' ? (
              <Descriptions.Item label="">
                <Tag
                  color={
                    questionStatus === 'Published'
                      ? 'green'
                      : questionStatus === 'Rejected at Review' || questionStatus === 'Rejected at Approval' || questionStatus === 'Retired'
                      ? 'volcano'
                      : questionStatus === 'Open (Require Amending)' || questionStatus === 'For Review (Require Amending)'
                      ? 'pink'
                      : 'geekblue'
                  }
                >
                  {questionStatus}
                </Tag>
              </Descriptions.Item>
            ) : null}
          </Descriptions>
          <Descriptions size="small">
            {record?.work_request_id && (
              <Col span={24}>
                <Descriptions.Item label="Work Request" style={{ display: 'block' }}>
                  <Button
                    size="small"
                    type="link"
                    onClick={() => {
                      if (record?.work_request_id) show('work_requests', record?.work_request_id)
                    }}
                  >
                    {`#${record?.work_request?.request_id ?? ''} ${record?.work_request?.name ?? ''}`}
                  </Button>
                </Descriptions.Item>
              </Col>
            )}

            <Descriptions.Item label="Grade">
              {console.log(record?.work_request,": work request",record?.question_grades,"question grades")}
              {JSON.stringify(record?.work_request?.workRequestGrades) !== '[]' && record?.work_request?.workRequestGrades !== undefined
                ? record?.work_request?.workRequestGrades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)
                : JSON.stringify(record?.question_grades) !== '[]'
                ? record?.question_grades?.map((item: any) => <Tag key={item?.grade_id}>{item?.grade?.name}</Tag>)
                : null}
            </Descriptions.Item>
            {/* <Descriptions.Item label="Grade">{renderGrades(record?.grade_ids)}</Descriptions.Item> */}

            <Descriptions.Item label="Subject">{record?.subject?.name}</Descriptions.Item>
            {/* <Descriptions.Item label="Report Theme">{record?.report_theme?.name}</Descriptions.Item> */}
            <Descriptions.Item label="Theme">{record?.theme?.name}</Descriptions.Item>
            <Descriptions.Item label="Sub-theme">{record?.sub_theme?.name}</Descriptions.Item>
            <Descriptions.Item label="Topic">{record?.topic?.name}</Descriptions.Item>
            <Descriptions.Item label="Question Type">
              {record?.question_type?.name &&
                (record?.work_request?.request_type === 'PC' ? `Parent Child / ${record.question_type.name}` : record.question_type.name)}
            </Descriptions.Item>
            {record?.language && <Descriptions.Item label="Language">{record?.language}</Descriptions.Item>}
            {record?.source && <Descriptions.Item label="Source">{record?.source}</Descriptions.Item>}
            {record?.variant_of && <Descriptions.Item label="Variant Of">{`${record?.variant_of}-(Question Id)`}</Descriptions.Item>}
            {record?.transilation_of && <Descriptions.Item label="Transilation Of">{`${record?.transilation_of}-(Question Id)`}</Descriptions.Item>}
            <Descriptions.Item>
              <Tooltip title="Click to view discrimination Index">
                <Button
                  onClick={() => {
                    showDIModal()
                  }}
                >
                  Discrimination Index
                </Button>
              </Tooltip>
            </Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: '0' }} />
          <b>Tags:</b>
          <Descriptions size="small">
            <Descriptions.Item label="Competency">{record?.competencies?.name}</Descriptions.Item>
            <Descriptions.Item label="Taxonomy">{record?.tn_taxonomy?.name}</Descriptions.Item>
            <Descriptions.Item label="Teacher Level">
              {record?.strand_id !== null && record?.strand_id !== undefined && record?.strand_id !== '' ? teacherLevel : ''}
            </Descriptions.Item>
            <Descriptions.Item label="Standard">{record?.strand?.name}</Descriptions.Item>
            <Descriptions.Item label="Bloom Level">{record?.bloom_level?.name}</Descriptions.Item>
            <Descriptions.Item label="Difficulty">{record?.difficulty_level?.name}</Descriptions.Item>

            {/* <Descriptions.Item label="Centa Standard">{record?.centa_standard?.name}</Descriptions.Item> */}
            <Descriptions.Item label="Centa Concept">{record?.centa_concept?.name}</Descriptions.Item>
            <Descriptions.Item label="Explanation Type">{record?.explanation_type?.name}</Descriptions.Item>
            <Descriptions.Item label="Custom Tag">{record?.custom_tag}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ margin: ' 0' }} />
          {/* <b>Users:</b> */}
          <Row gutter={[16, 0]}>
            <Col xs={24} lg={8}>
              <div>
                <b>Creator</b>

                <div> {record?.userByCreatorId?.displayName}</div>
              </div>
            </Col>

            {renderApproverReviewerUsers()}
          </Row>
          <Descriptions size="small" column={2}>
            {/* {userRole!=='qcreator'? */}
            <Descriptions.Item label="Reviewer Stem Comments">{record?.reviewer_stem_comments}</Descriptions.Item>
            {/* // :null} */}
            {userRole !== 'qcreator' ? <Descriptions.Item label="Approver Stem Comments">{record?.approver_stem_comments}</Descriptions.Item> : null}
            {userRole !== 'qcreator' ? <Descriptions.Item label="R2 Comments">{record?.second_reviewer_comments}</Descriptions.Item> : null}
            {userRole !== 'qcreator' ? <Descriptions.Item label="A2 Comments">{record?.second_approver_comments}</Descriptions.Item> : null}
          </Descriptions>
          <Divider style={{ margin: ' 0' }} />
          {record?.parent_question && (
            <>
              <b>Parent Question:</b>
              <Descriptions size="small" column={1} layout="vertical">
                <Descriptions.Item>{`${record?.parent_question?.question_id}. ${record?.parent_question?.title}`}</Descriptions.Item>
              </Descriptions>
            </>
          )}
          {record && record?.work_request?.request_type === 'PC' && record?.parent_child_question_reference_data?.reference_data && (
            <>
              <b>Reference Text:</b>
              <Descriptions size="small" column={1} layout="vertical">
                <Descriptions.Item className="reference_text">
                  {!isLoading ? (
                    <SunTextEditor
                      key={record?.reference_data_id}
                      id={`reference_text_show`}
                      initialValue={record?.parent_child_question_reference_data?.reference_data}
                      hideToolBar={true}
                    />
                  ) : (
                    <p style={{ textAlign: 'center' }}>Loading............</p>
                  )}
                </Descriptions.Item>
              </Descriptions>
            </>
          )}
          <b>Question:</b>
          <Descriptions size="small" column={1} layout="vertical">
            <Descriptions.Item className="question-title">
              {/* <ReactMarkdown className="text-space">{`${record?.title}`}</ReactMarkdown> */}
              {/* <RichTextEditor id="question_title_show" initialValue={record?.title} hideToolBarAndMenu /> */}
              {!isLoading ? (
                <SunTextEditor key={record?.title} id={`question_title_show`} initialValue={record?.title} hideToolBar={true} />
              ) : (
                <p style={{ textAlign: 'center' }}>Loading............</p>
              )}
            </Descriptions.Item>
          </Descriptions>

          {record?.option_details && record?.question_type_id === 'MCQ' && (
            <Radio.Group onChange={onChange} value={value}>
              {record?.option_details?.map((option: any, idx: number) => {
                if (option.option_image_id && option?.option_type === 'Image') {
                  const publicUrl = nhost.storage.getPublicUrl({ fileId: option?.option_image_id })
                  return (
                    <Radio key={idx} value={idx + 1}>
                      {publicUrl && <Image width={100} height={100} src={publicUrl} style={{ margin: 0, objectFit: 'contain' }} />}
                    </Radio>
                  )
                } else {
                  return (
                    <Radio key={idx} value={idx + 1}>
                      {/* {option?.option_text} */}
                      <RichTextRender content={option?.option_text} styles={{ width: undefined, height: undefined }} />
                    </Radio>
                  )
                }
              })}
            </Radio.Group>
          )}
          {record?.option_details && record?.question_type_id === 'Match' && (
            <div>
              <Table
                style={{ display: 'inline-block', minWidth: '300px' }}
                showHeader={false}
                size="small"
                bordered
                columns={[
                  {
                    title: 'Left Label',
                    dataIndex: 'left_label_text',
                    render: (text, record, index) => {
                      if (record?.left_label_image) {
                        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.left_label_image })
                        return (
                          <>
                            {publicUrl && (
                              <>
                                {roman[index + 1]}
                                {')   '}
                                <Image width={100} height={100} style={{ marginLeft: 0, objectFit: 'contain' }} src={publicUrl} />
                              </>
                            )}
                          </>
                        )
                      } else {
                        return (
                          <>
                            {
                              <>
                                {roman[index + 1]}
                                {')   '}
                                {/* {record?.left_label_text} */}
                                <RichTextRender content={record?.left_label_text} styles={{ width: undefined, height: undefined }} />
                              </>
                            }
                          </>
                        )
                      }
                    },
                  },
                  {
                    title: 'Right Label',
                    dataIndex: 'right_label_text',
                    render: (text, record, index) => {
                      if (record?.right_label_image) {
                        const publicUrl = nhost.storage.getPublicUrl({ fileId: record?.right_label_image })
                        return (
                          <>
                            {publicUrl && (
                              <>
                                {alphabets[index + 1]}
                                {')   '}
                                <Image width={100} height={100} style={{ marginLeft: 0, objectFit: 'contain' }} src={publicUrl} />
                              </>
                            )}
                          </>
                        )
                      } else {
                        return (
                          <>
                            {
                              <>
                                {alphabets[index + 1]} {')   '}
                                {/* {record?.right_label_text} */}
                                <RichTextRender content={record?.right_label_text} styles={{ width: undefined, height: undefined }} />
                              </>
                            }
                          </>
                        )
                      }
                    },
                  },
                ]}
                dataSource={record?.option_details}
                pagination={false}
              />
            </div>
          )}
          <Divider style={{ margin: '12px 0' }} />

          {record?.question_type_id === 'ShortAnswer' && (
            <>
              <b>Expected points in the answer:</b>
              <p>{record?.description}</p>
              <Divider style={{ margin: '12px 0' }} />
            </>
          )}
          {record?.option_details && (
            <>
              {record?.question_type_id === 'MCQ' && (
                <>
                  <b>Option Details :</b>
                  <Table size="small" columns={MCQColumns}  scroll={{ x: true }} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'Match' && (
                <>
                  <b>Label Details:</b>
                  <Table size="small" columns={MatchColumns} scroll={{ x: true }} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'Fill' && (
                <>
                  <b>Answer Details:</b>
                  <Table size="small" columns={FillColumns} scroll={{ x: true }} dataSource={record?.option_details} pagination={false} />
                </>
              )}
              {record?.question_type_id === 'ShortAnswer' && (
                <>
                  <b>Rubric Details:</b>
                  <Table size="small" columns={ShortAnswerColumns} scroll={{ x: true }} dataSource={record?.option_details} pagination={false} />
                </>
              )}
            </>
          )}

          {!record && <Skeleton paragraph={{ rows: 1 }} />}
          <EditQuestion modalProps={editModalProps} formProps={editFormProps} record={record} close={close} source="questions_show" />
          <DiscriminationIndex question={record} close={closeDIModal} modalProps={DIModalProps} />
        </PageHeader>
      ) : (
        <ErrorComponent />
      )}
    </>
  )
}
